import { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { getFontScale } from 'themes/mixins/getFontScale';
import { mediaMinWidth } from 'themes/mixins/mediaQueries';

const motives = {
  default: css`
    label {
      height: 1.9rem;
      margin: 1rem 0 1rem 0;

      text-transform: uppercase;
      font-size: 0.9rem;
      font-family: 'LFT Zeno light', sans-serif;
      font-weight: 600;
      letter-spacing: 0.1rem;

      color: ${pickColor('grayLabel')};

      ${mediaMinWidth.md(css`
        margin-bottom: 1.6rem;

        letter-spacing: 0;
      `)}
    }
  `,
  filter: css`
    label {
      margin-bottom: 0.4rem;

      font-family: 'LFT Zeno', sans-serif;
      font-size: 1.2rem;
      font-weight: 600;
    }
  `,
  orderTable: css`
    min-width: 5rem;

    ${getFontScale('xs')}
  `,
};

export type SelectMotives = keyof typeof motives;

const pickMotive = (motive: SelectMotives) => motives[motive];

export { pickMotive };
